export { SpanStatusCode } from '@opentelemetry/api';

export type { Span, SpanOptions } from '@opentelemetry/api';
